import { analyticsIds } from '../../../../constants/analyticsIds';
import { filterOperators, filterTypes } from '../../../../redux/blueprints/search';

import { ColumnTypes } from './columns';

export const presetFilterNames = {
  expired: 'expired',
  nonCompliant: 'non-compliant',
  pending: 'pending review',
  delinquent: 'delinquent',
  records: 'all records'
};

export const presetFilterToolMap = [
  {
    analyticsId: analyticsIds.reportsPage.expiredPresetButton,
    num: 'expiredCount',
    name: presetFilterNames.expired,
    color: 'error.primary.600',
    info: 'Shows the number of records that have expired policies.'
  },
  {
    analyticsId: analyticsIds.reportsPage.nonCompliantPresetButton,
    num: 'nonCompliantCount',
    name: presetFilterNames.nonCompliant,
    color: 'caution.primary.600',
    info: 'Shows the number of records that have policy submissions with a Non-Compliant status.'
  },
  {
    analyticsId: analyticsIds.reportsPage.pendingReviewPresetButton,
    num: 'pendingCount',
    name: presetFilterNames.pending,
    color: 'success.primary.600',
    info: 'Shows the number of records that have policy submissions with a Pending status.'
  },
  {
    analyticsId: analyticsIds.reportsPage.delinquentPresetButton,
    num: 'delinquentCount',
    name: presetFilterNames.delinquent,
    color: 'primaryScale.300',
    info: 'Shows the number of records that have requirements with a Not Received status.'
  },
  {
    analyticsId: analyticsIds.reportsPage.insuredsPresetButton,
    num: 'insuredCount',
    name: presetFilterNames.records,
    color: 'primaryScale.600',
    info: 'Resets quick filters and shows all insureds with project assignments.'
  }
];

const presetFilters = {
  [presetFilterNames.expired]: {
    advancedFilters: [
      {
        shouldQuery: true,
        presetName: presetFilterNames.expired,
        operator: filterOperators.isEqualTo,
        property: {
          entity: 'requirement',
          name: 'Requirement Status',
          keys: [
            'insurance_requirement.properties.status',
            'insurance_requirement.documents.status'
          ],
          type: filterTypes.string
        },
        value: 'expired'
      }
    ],
    columns: [
      ColumnTypes.Checkbox,
      ColumnTypes.Insured,
      ColumnTypes.ExternalId,
      ColumnTypes.ParentId,
      ColumnTypes.JobInfo,
      ColumnTypes.Policy
    ]
  },
  [presetFilterNames.nonCompliant]: {
    advancedFilters: [
      {
        shouldQuery: true,
        presetName: presetFilterNames.nonCompliant,
        operator: filterOperators.isEqualTo,
        property: {
          entity: 'requirement',
          name: 'Requirement Status',
          keys: [
            'insurance_requirement.properties.status',
            'insurance_requirement.documents.status'
          ],
          type: filterTypes.string
        },
        value: 'non_compliant'
      }
    ],
    columns: [
      ColumnTypes.Checkbox,
      ColumnTypes.Insured,
      ColumnTypes.ExternalId,
      ColumnTypes.ParentId,
      ColumnTypes.JobInfo,
      ColumnTypes.Requirements,
      ColumnTypes.Policy
    ]
  },
  [presetFilterNames.pending]: {
    advancedFilters: [
      {
        shouldQuery: true,
        presetName: presetFilterNames.pending,
        operator: filterOperators.isEqualTo,
        property: {
          entity: 'requirement',
          name: 'Requirement Status',
          keys: [
            'insurance_requirement.properties.status',
            'insurance_requirement.documents.status'
          ],
          type: filterTypes.string
        },
        value: 'pending'
      }
    ],
    columns: [
      ColumnTypes.Checkbox,
      ColumnTypes.Insured,
      ColumnTypes.ExternalId,
      ColumnTypes.ParentId,
      ColumnTypes.Requirements,
      ColumnTypes.Policy
    ]
  },
  [presetFilterNames.delinquent]: {
    advancedFilters: [
      {
        shouldQuery: true,
        presetName: presetFilterNames.delinquent,
        operator: filterOperators.isEqualTo,
        property: {
          entity: 'requirement',
          name: 'Requirement Status',
          keys: [
            'insurance_requirement.properties.status',
            'insurance_requirement.documents.status'
          ],
          type: filterTypes.string
        },
        value: 'not_received'
      }
    ],
    columns: [
      ColumnTypes.Checkbox,
      ColumnTypes.Insured,
      ColumnTypes.ExternalId,
      ColumnTypes.ParentId,
      ColumnTypes.JobInfo,
      ColumnTypes.OverallStatus
    ]
  },
  [presetFilterNames.records]: {
    advancedFilters: [],
    columns: [
      ColumnTypes.Checkbox,
      ColumnTypes.Insured,
      ColumnTypes.ExternalId,
      ColumnTypes.ParentId,
      ColumnTypes.JobInfo,
      ColumnTypes.Items
    ]
  }
};

export default presetFilters;
